export const formatDateToLocale = (date?: string | Date, showtime = false) => {
    if (!date) {
        return '';
    }

    const getValue = (d: Date) =>
        showtime
            ? `${d.toLocaleDateString()} ${d.getHours()}:${d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes()}`
            : d.toLocaleDateString();

    if (typeof date === 'string') {
        const d = new Date(date);

        return getValue(d);
    }

    return getValue(date);
};

export const getMonthName = (monthNumber: number) => {
    if (!monthNumber) {
        return '';
    }

    const date = new Date();

    date.setDate(1);
    date.setMonth(monthNumber - 1);

    return date.toLocaleString('ru-Ru', { month: 'long' });
};

export const getDateParts = (date: string | Date) => {
    const d = new Date(date);

    return {
        day: d.getDate(),
        month: getMonthName(d.getMonth() + 1),
        year: d.getFullYear(),
    };
};

export const getDateIncludingCurrentTime = (date: Date) => {
    if (!date) {
        return undefined;
    }

    const current = new Date();

    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), current.getHours(), current.getMinutes(), 0);
};

export const getDateOnly = (date?: Date | string) => {
    if (!date) {
        return '';
    }

    const getValue = (d: Date) => {
        const { day, month, year } = { day: d.getDate(), month: d.getMonth() + 1, year: d.getFullYear() };

        return `${year}-${month}-${day}`;
    };

    if (typeof date === 'string') {
        const d = new Date(date);

        return getValue(d);
    }

    return getValue(date);
};
